module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="jquery-modal blocker" id="resume-attached-overlay" style="display:none;">\n  <div id="resume-attached-modal" class="modal modal-small">\n    <h3>Upload resum&eacute;</h3>\n    <div class="js-resume"></div>\n  </div>\n</div>\n';

}
return __p
}